<div class="w-12"
     #container></div>
<result class="w-12 p-t-4-s"
        duration="permanent"
        [status]="applePayAvailableStatus" />
<result class="w-12 p-t-4-s"
        duration="permanent"
        [status]="scriptStatus" />
<result class="w-12 p-t-4-s"
        duration="permanent"
        [status]="validateMerchantStatus" />